import { ActivatedRouteSnapshot } from '@angular/router';

export class RouterHelper {
    public static getRecursiveStates(rootArs: ActivatedRouteSnapshot): ActivatedRouteSnapshot[] {
        const result = [];
        if (rootArs) {
            result.push(rootArs);
            if (rootArs.children) {
                for (const child of rootArs.children) {
                    result.push(...RouterHelper.getRecursiveStates(child));
                }
            }
        }
        return result;
    }
}
